/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PodNamesQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PodNamesQueryOperator");
    }

    getFixupPrototypeFunction() { return PodNamesQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PodNamesQueryOperator>): PodNamesQueryOperator {
        let obj = Object.assign(new PodNamesQueryOperator(), model);
        PodNamesQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PodNamesQueryOperator>): PodNamesQueryOperator {
        if (!model) return null;
        return PodNamesQueryOperator.newInstance(<PodNamesQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PodNamesQueryOperator) {
        if (!obj) return;

        models.PodNamesQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PodNamesQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PodNamesQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Pod Names to include
     */
    pod_names: Array<string>;

}
